






























































































































import { Component, Mixins } from 'vue-property-decorator';
import GlobalMixins from '@/plugins/mixins';
import HomeBanner from './HomeBanner.vue';
import HomeFooter from './HomeFooter.vue';
import { Imgs } from 'types/index';

@Component({
	components: {
		HomeBanner,
		HomeFooter,
	},
})
export default class Home extends Mixins(GlobalMixins) {
	private imgs: Imgs = {
		img1: require('assets/home/image-1.svg'),
		img2: require('assets/home/image-2.svg'),
		img3: require('assets/home/image-3.gif'),
		foot: require('assets/home/foot-banner.jpg'),
	};

	public mounted() {
		this.$logger.debug('app', 'Home mounted');
	}
}
